export const GET_TEST_DEFINITIONS = "/testdefinition"
export const ADD_NEW_TEST_DEFINITION = "/add/testdefinition"
export const UPDATE_TEST_DEFINITION = "/update/testdefinition"
export const DELETE_TEST_DEFINITION = "/delete/testdefinition"
export const DYNAMIC_LIST = "/Dynamic/getdynamiclist"
export const DEFAULT = "/Dynamic/getdynamiclist"
